// Brand configuration for NewDayStays
export const BRAND = {
  namePrefix: "New Day",
  nameSuffix: "Stays",
  fullName: "NewDayStays",
  domain: "newdaystays.in",
  email: "newdaystay@gmail.com",
  // WhatsApp number in international format WITHOUT + or spaces (wa.me format)
  // Update this to the real business number.
  whatsapp: "916360734483",
  whatsappDisplay: "+91 63607 34483",
  instagram: "@newdaystays",
};

export function whatsappUrl({ propertyTitle, address, checkIn, checkOut, guests } = {}) {
  const parts = [`Hi ${BRAND.fullName}, I'd like to enquire about a stay.`];
  if (propertyTitle) parts.push(`\n\nProperty: ${propertyTitle}`);
  if (address) parts.push(`Location: ${address}`);
  if (checkIn && checkOut) parts.push(`Dates: ${checkIn} → ${checkOut}`);
  if (guests) parts.push(`Guests: ${guests}`);
  parts.push(`\nCould you share availability and best rate?`);
  const text = encodeURIComponent(parts.join("\n"));
  return `https://wa.me/${BRAND.whatsapp}?text=${text}`;
}
